export default "__VITE_ASSET__BQzsvq2o__"